<div class="page-wrapper">

  <!-- Page title -->
  <h1 class="page-title">{{ pageTitle }}</h1>

  <!-- Stepper -->
  <app-stepper [currentStep]="1" />

  <!-- Main layout -->
  <div class="content-layout">

    <!-- Left: Main content -->
    <main class="main-content">
      <h2 class="section-title">{{ userProfile.profile?.owner?.name ?? '' }}, let's file your {{ filingNoun }}</h2>

      <!-- Assessment vs market value card -->
<!--      <div class="card evidence-card">-->
<!--        <div class="card-header">-->
<!--          <ngk-icon icon="chart-column" size="1.1rem" color="var(&#45;&#45;color-neutral-600)" />-->
<!--          <div>-->
<!--            <p class="card-title">Assessment vs. market value</p>-->
<!--            <p class="card-subtitle">{{ assessment.data?.property?.county }} CAD + comparable sales, {{ (assessment.data?.assessment?.taxYear ?? 1) - 1 }}</p>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="stats-grid">-->
<!--          <div class="stat-cell">-->
<!--            <p class="stat-label">CURRENT ASSESSED VALUE</p>-->
<!--            <p class="stat-value">{{ assessment.data?.assessment?.assessedValue | currency:'USD':'symbol':'1.0-0' }}</p>-->
<!--            <p class="stat-note">Set by {{ assessment.data?.property?.county }}, {{ (assessment.data?.assessment?.taxYear ?? 1) - 1 }}</p>-->
<!--          </div>-->
<!--          <div class="stat-cell">-->
<!--            <p class="stat-label">Average Neighborhood Assessment</p>-->
<!--            <p class="stat-value stat-value&#45;&#45;positive">{{ assessment.data?.assessment?.marketValueEstimate | currency:'USD':'symbol':'1.0-0' }}</p>-->
<!--            <p class="stat-note">Based on historical data</p>-->
<!--          </div>-->
<!--          <div class="stat-cell">-->
<!--            <p class="stat-label">OVER-ASSESSMENT GAP</p>-->
<!--            <p class="stat-value stat-value&#45;&#45;danger">{{ assessment.data?.assessment?.overAssessmentGap | currency:'USD':'symbol':'1.0-0' }}</p>-->
<!--            <p class="stat-note">What we'd argue to reduce</p>-->
<!--          </div>-->
<!--        </div>-->

<!--      </div>-->

<!-- Why flagged card -->
<!--      <div class="card evidence-card">-->
<!--        <div class="card-header">-->
<!--          <ngk-icon icon="flag" size="1.1rem" color="var(&#45;&#45;color-neutral-600)" />-->
<!--          <p class="card-title">Why your property was flagged</p>-->
<!--        </div>-->
<!--        <div class="flag-tags">-->
<!--          @for (flag of assessment.data?.flags; track flag.type) {-->
<!--            <ngk-chip [color]="flag.severity === 'warning' ? 'warning' : 'neutral'" variant="outlined" size="sm" [prefixIcon]="flag.icon">{{ flag.label }}</ngk-chip>-->
<!--          }-->
<!--        </div>-->
<!--        <p class="flag-description">-->
<!--          Flood-zone properties like yours are frequently over-assessed — county appraisers are-->
<!--          slow to reflect flood risk in their valuations. This gives you a strong unequal appraisal-->
<!--          argument.-->
<!--        </p>-->
<!--      </div>-->
<!--      <app-projected-savings />-->

      <!-- Fee callout. Guarded on estimatedSavings !== null (not just the object existing) because
           a jurisdiction with no rate/tax-bill source data leaves it null, and the currency/number
           pipes would otherwise render a blank or misleading value rather than hiding the section. -->
      @if (assessment.data?.taxBreakdown; as tb) {
        @if (tb.estimatedSavings !== null) {
        <div class="fee-compare card">
          <table class="fee-table">
            <thead>
              <tr class="fee-table-head">
                <th class="fee-th fee-th--provider">Provider</th>
                <th class="fee-th">Fee</th>
                <th class="fee-th">Their cut on<br>${{ tb.estimatedSavings | number:'1.0-0' }}</th>
                <th class="fee-th">You keep</th>
              </tr>
            </thead>
            <tbody>
              <tr class="fee-row fee-row--competitor">
                <td class="fee-td fee-td--provider">Typical industry</td>
                <td class="fee-td">25–50%</td>
                <td class="fee-td">${{ (tb.estimatedSavings * .25) | number:'1.0-0' }} – {{ (tb.estimatedSavings * .5) | number:'1.0-0' }}</td>
                <td class="fee-td">${{ (tb.estimatedSavings * .5) | number:'1.0-0' }} – {{ (tb.estimatedSavings * .75) | number:'1.0-0' }}</td>
              </tr>
              <tr class="fee-row fee-row--kin">
                <td class="fee-td fee-td--provider"><strong class="fee-kin-logo">kin.</strong></td>
                <td class="fee-td fee-td--kin">10%</td>
                <td class="fee-td fee-td--kin">${{ (tb.estimatedSavings * .1) | number:'1.0-0' }}</td>
                <td class="fee-td fee-td--kin">${{ (tb.estimatedSavings * .9) | number:'1.0-0' }}</td>
              </tr>
            </tbody>
          </table>
          <p class="fee-disclaimer">Based on a ${{ tb.estimatedSavings | number:'1.0-0' }} savings estimate. Past results don't guarantee future savings. Actual results depend on your property and {{ filingNoun }} outcome.</p>
        </div>
        }
      }

      <!-- Details card -->
      <div class="details-card card">
        <div class="card-header">
          <div class="card-header-icon">
            <ngk-icon icon="user" size="1.1rem" />
          </div>
          <div>
            <p class="card-title">Filing on behalf of</p>
            <p class="card-subtitle">From your Kin account</p>
          </div>
        </div>

        <div class="details-list">
          @for (row of details; track row.label) {
            <div class="detail-row">
              <span class="detail-label">{{ row.label }}</span>
              <div class="detail-value-group">
                <div class="detail-value-inner">
                  <span class="detail-value" [class.detail-value--highlight]="row.highlight">{{ row.value }}</span>
                  @if (row.sub) {
                    <p class="detail-sub">{{ row.sub }}</p>
                  }
                </div>
                <ngk-icon icon="circle-check" size="1.1rem" color="var(--color-secondary-600)" />
              </div>
            </div>
          }
        </div>

        <div class="contact-note">
          Something look wrong? <a href="tel:214-216-6542" class="contact-link">Contact us</a> and we'll fix it before filing.
        </div>
      </div>

      <!-- Continue button -->
      <button ngkButton color="secondary" mode="solid" size="md" [prefixIcon]="'arrow-right'" class="file-btn" [disabled]="submitting" (click)="submit()">
        {{ submitting ? 'Creating case…' : 'Continue' }}
      </button>
      @if (submitError) {
        <p class="submit-error">{{ submitError }}</p>
      }
      <p class="file-note">
        <ngk-icon icon="lock" size="0.9rem" color="var(--color-neutral-500)" />
        No payment now. We file before {{ filingDeadline | date:dateFormat }}.
      </p>
    </main>

    <!-- Right: Sidebar -->
    <app-property-sidebar />
  </div>
</div>
